
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide/[id]",
      function () {
        return require("private-next-pages/guide/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guide/[id]"])
      });
    }
  